import { observable, action, decorate } from "mobx"

class UIStore {
  @observable isOpenedCTA = 'none'
  @observable ctaPositionTop = 0
}
const UIStoreContainer = new UIStore()
export default UIStoreContainer
